import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { ToastContainer, toast, Bounce } from "react-toastify";
import LoginLayout from "../appLayouts/login";
import "./index.scss";
import { checkEmailExistence } from "../../services/params";
import SubmitBtn from "../submitButton";
import SelectForm from "../selectForm";

function CreateDevisForm({ isLoading = false }) {
  const { t } = useTranslation();
  const location = useLocation(); // Utiliser useLocation ici
  const { user } = location.state || {}; // Récupérer les données du step 1 depuis location.state
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    activitySector: "",
    company: "",
    servicesDemandes: "",
    budgetEstime: "",
    description: "",
    dateSoumission: "",
    KBIS: null,
    pieceJointe: null,
    devise: "EUR",
    SIRET: "",
    SIREN: "",
  });

  const [errors, setErrors] = useState({});
  const [pdf, setPdf] = useState(null);

  const validateForm = () => {
    const newErrors = {};

    if (!formData.activitySector)
      newErrors.activitySector = t("Ce champ est requis.");
    if (!formData.company) newErrors.company = t("Ce champ est requis.");
    if (!formData.servicesDemandes)
      newErrors.servicesDemandes = t("Ce champ est requis.");
    if (!formData.budgetEstime)
      newErrors.budgetEstime = t("Ce champ est requis.");
    if (!formData.description)
      newErrors.description = t("Ce champ est requis.");
    if (!formData.dateSoumission)
      newErrors.dateSoumission = t("Ce champ est requis.");

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    const file = files[0];
    if (name === "pieceJointe") {
      setPdf(file);
    } else {
      setFormData((prev) => ({ ...prev, [name]: file }));
    }
  };

  const handleFinalSubmit = async (event) => {
    event.preventDefault();

    try {
      const exists = await checkEmailExistence(user?.email, user?.id);

      if (exists) {
        toast.error("Cet email est déjà utilisé. Veuillez en saisir un autre.");
        return;
      }
      const devisData = {
        activitySector: formData.activitySector,
        company: formData.company,
        servicesDemandes: formData.servicesDemandes,
        budgetEstime: formData.budgetEstime,
        description: formData.description,
        dateSoumission: formData.dateSoumission,
        devise: formData.devise,
        SIRET: formData.SIRET,
        SIREN: formData.SIREN,
      };

      const formDataToSend = new FormData();
      formDataToSend.append("user", JSON.stringify(user));
      formDataToSend.append("devis", JSON.stringify(devisData));

      if (formData.KBIS) {
        formDataToSend.append("KBIS", formData.KBIS);
      }
      if (formData.SIREN) {
        formDataToSend.append("SIREN", formData.SIREN);
      }
      if (formData.pieceJointe) {
        formDataToSend.append("pieceJointe", formData.pieceJointe);
      }

      await axios.post("/users/createDevisAndUser", formDataToSend, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      toast.success("Utilisateur et devis créés !");
      navigate("/confirmation");
    } catch (error) {
      console.error(error);
      toast.error("Erreur lors de la création");
    }
  };

  return (
    <div
      id="login-page"
      className="login-page  "
      style={{ minHeight: "180vh" }}>
      <LoginLayout title="Créez votre première demande de devis">
        <form
          // className="create-devis-form"
          onSubmit={handleFinalSubmit}
          // id="LoginForm"
        >
          <div className="row mailing-section p-3">
            <div className="col-lg-12">
              <div className="mb-3 mt-4 secteur-title">
                {t("Secteur d’activité")}
              </div>
              <input
                type="text"
                className="form-control"
                name="activitySector"
                value={formData.activitySector}
                onChange={handleChange}
                required
              />
              {errors.activitySector && (
                <div className="text-danger mt-1">{errors.activitySector}</div>
              )}
            </div>

            <div className="col-lg-12">
              <div className="mb-3 mt-4 secteur-title">{t("Entreprise")}</div>
              <input
                type="text"
                className="form-control"
                name="company"
                value={formData.company}
                onChange={handleChange}
                required
              />
              {errors.company && (
                <div className="text-danger mt-1">{errors.company}</div>
              )}
            </div>

            <div className="col-lg-12">
              <div className="mb-3 mt-4 secteur-title">KBIS</div>
              <div className="custom-file-wrapper">
                <input
                  type="file"
                  name="KBIS"
                  className="custom-file-input"
                  onChange={handleFileChange}
                  accept=".pdf,.jpg,.jpeg,.png,.docx"
                  required
                  id="kbisUpload"
                />
                <div className="custom-file-placeholder">
                  {formData.KBIS?.name ||
                    "(upload de fichiers, formats acceptés : PDF, JPG, PNG, DOCX)"}
                  <button
                    type="button"
                    className="custom-upload-btn"
                    onClick={() =>
                      document.getElementById("kbisUpload").click()
                    }>
                    Joindre
                  </button>
                </div>
              </div>
            </div>

            <div className="col-lg-12">
              <div className="mb-3 mt-4 secteur-title">
                {t("Types de services souhaités")}
              </div>
              <input
                type="text"
                className="form-control"
                name="servicesDemandes"
                value={formData.servicesDemandes}
                onChange={handleChange}
                required
                placeholder={t("Ex: Création de site web")}
              />
              {errors.servicesDemandes && (
                <div className="text-danger mt-1">
                  {errors.servicesDemandes}
                </div>
              )}
            </div>

            <div className="col-lg-12">
              <div className="mb-3 mt-4 secteur-title text-start">
                {t("Budget estimé HT")}
              </div>
              <div className="d-flex gap-2">
                <input
                  type="number"
                  className="form-control"
                  name="budgetEstime"
                  required
                  onChange={handleChange}
                  value={formData.budgetEstime}
                  style={{ flex: 2 }}
                />
                <div style={{ flex: 1 }}>
                  <SelectForm
                    options={[{ value: "EUR", name: "EUR" }]}
                    name="devise"
                    onChangeFunction={handleChange}
                    value={formData.devise}
                  />
                </div>
              </div>
              {errors.budgetEstime && (
                <div className="text-danger mt-1">{errors.budgetEstime}</div>
              )}
            </div>

            <div className="col-lg-12">
              <div className="mb-3 mt-4 secteur-title">
                {t("Description détaillée de votre projet")}
              </div>
              <textarea
                className="form-control"
                name="description"
                rows="4"
                required
                value={formData.description}
                onChange={handleChange}
                placeholder="Ajoutez une description détaillée de votre projet"
              />
              {errors.description && (
                <div className="text-danger mt-1">{errors.description}</div>
              )}
            </div>

            <div className="col-lg-12">
              <div className="mb-3 mt-4 secteur-title">
                {t("Date de création de projet")}
              </div>
              <input
                type="date"
                className="form-control"
                name="dateSoumission"
                value={formData.dateSoumission}
                required
                onChange={handleChange}
              />
              {errors.dateSoumission && (
                <div className="text-danger mt-1">{errors.dateSoumission}</div>
              )}
            </div>
            <div className="col-lg-12">
              <div className="mb-3 mt-4 secteur-title">Pièce Jointe</div>
              <div className="custom-file-wrapper">
                <input
                  type="file"
                  name="pieceJointe"
                  className="custom-file-input"
                  onChange={handleFileChange}
                  accept=".pdf,.jpg,.jpeg,.png,.docx"
                  id="fileUpload"
                />
                <div className="custom-file-placeholder">
                  {pdf?.name ||
                    "(upload de fichiers, formats acceptés : PDF, JPG, PNG, DOCX)"}
                  <button
                    type="button"
                    className="custom-upload-btn"
                    onClick={() =>
                      document.getElementById("fileUpload").click()
                    }>
                    Joindre
                  </button>
                </div>
              </div>
            </div>
          </div>
          <SubmitBtn value={"Enregistrer"} disabled={isLoading} />
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick={false}
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="dark"
            transition={Bounce}
          />
        </form>
      </LoginLayout>
    </div>
  );
}

export default CreateDevisForm;
